var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("lz-panel", {
    ref: "panel",
    attrs: { panelClass: _vm.panelClass },
    on: { updated: ($event) => (this.panelId = $event.panelId) },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }